import axios from "@/axios";

let userPromise = null;

export default {
	state: {
		id: "",
		role: "",
		username: "",
		organisation: "",
		sub: "",
		modules: {
			templates: true,
		},
	},
	mutations: {
		setUser(state, user) {
			if (!user) return;
			const { id, username, role, organisation } = user || {};
			state.id = id;
			state.username = username;
			state.role = role;
			state.organisation = organisation;
			state.sub = user.sub;
			state.modules = {
				...state.modules,
				...(user.modules || {}),
			};
		}
	},
	actions: {
		updateUser({ commit }, user) {
			commit("setUser", user);
		},
		fetchUser({ commit }) {
			if (!userPromise) {
				userPromise = axios
					.get("/api/user")
					.then(({ data }) => {
						commit("setUser", data.user);
					})
					.catch((error) => {
						userPromise = null;
						return Promise.reject(error);
					});
			}
			return userPromise;
		}
	},
	getters: {
		getUser(state) {
			return {
				id: state.id,
				role: state.role,
				username: state.username,
				organisation: state.organisation,
				sub: state.sub,
			};
		},
		templateModuleEnabled(state) {
			return state.modules.templates;
		}
	}
};
